export default __webpack_public_path__ + "static/media/1.930da2b8.svg";